export const LIMIT_TYPE = Object.freeze({
    AUTOMATIC_WITHDRAW_LIMIT: 1,
    AMOUNT_TO_BE_LEFT_ON_BALANCE: 2
});

export const LIMIT_STATUS = Object.freeze({
    CURRENT: 1,
    PENDING: 2
});

export const UNLIMITED_DATE_VALUE = 2100;
